import SmartNavigate from './SmartNavigate';

function r(path, to) {
  return {
    path,
    element: (
      <SmartNavigate
        replace
        to={to}
      />
    )
  };
}

export default [
  r('/d/unsupported', '/dashboard'),
  r('/dashboard/:businessEntityUuid/bank-of-america-offer', '/dashboard/:businessEntityUuid/banking/bank-of-america-offer'),
  r(
    '/dashboard/:businessEntityUuid/tax-services',
    '/dashboard/:businessEntityUuid/money/tax-services'
  ),
  r(
    '/dashboard/:businessEntityUuid/education-studio',
    '/dashboard/:businessEntityUuid/education'
  ),
  r(
    '/dashboard/:businessEntityUuid/education-studio/*',
    '/dashboard/:businessEntityUuid/education/*'
  ),
  r(
    '/dashboard/:businessEntityUuid/insights/*',
    '/dashboard/:businessEntityUuid'
  ),
  r(
    '/dashboard/:businessEntityUuid/insights',
    '/dashboard/:businessEntityUuid'
  ),
  r(
    '/dashboard/:businessEntityUuid/subscription-hub-v2/subscription-cancel/:orderBillingItemUuid',
    '/dashboard/:businessEntityUuid/subscription-cancel/:orderBillingItemUuid'
  ),
  r(
    '/dashboard/:businessEntityUuid/subscription-hub/subscriptions',
    '/dashboard/subscription-hub/billing/subscriptions'
  )
];
